export default "__VITE_ASSET__DhBV9gEi__"